import styled from "styled-components";

export const Main = styled.main`
  align-self: flex-start;
  width: 100%;
`;
